<button type="button" class="dialog-close" (click)="dialogRef.close()">
  <svg-icon name="cross"></svg-icon
></button>
<p class="product-dialog__title" mat-dialog-title
  >You've added {{ data?.text | pluralize: data.tickets }} to basket</p
>

<div class="product-dialog__product">
  <div class="product-dialog__product-left">
    <img
      class="product-dialog__product-image"
      [src]="data?.product.thumbnail.url"
      [alt]="data?.product.title"
    />
  </div>

  <div class="product-dialog__product-right">
    <div class="product-dialog__product-title">
      {{ data?.product.title }}
    </div>
    <div class="product-dialog__product-tickets">
      {{ data.tickets }} {{ data?.text | pluralize: data.tickets }}
    </div>
  </div>
</div>

<div class="product-dialog__product-actions">
  <button
    [ngClass]="{
      'button button_border button_no-shadow': data.projectCode === '7days',
      'button-new button-new__outlined button-new__small button-new__primary':
        data.projectCode === 'ukcarp'
    }"
    type="button"
    (click)="dialogRef.close()"
    >Keep shopping</button
  >

  <ng-container
    *ngIf="data?.product.instant_win_count > 0 && cartNonEmpty; else toCartTmpl"
  >
    <a
      [ngClass]="{
        'button button_no-shadow button_blue': data.projectCode === '7days',
        'button-new button-new__small button-new__primary':
          data.projectCode === 'ukcarp'
      }"
      routerLink="/checkout"
      (click)="dialogRef.close()"
      >To checkout</a
    >
  </ng-container>
</div>

<div
  class="product-dialog__promo"
  *ngIf="data?.product.popup_raffle || data?.product.popup_category"
>
  <div
    class="product-dialog__body"
    [innerHtml]="data?.product.popup_text | safeHtml"
  ></div>

  <div class="product-dialog__footer product-dialog__footer_buttons">
    <a
      *ngIf="data?.product.popup_raffle"
      [routerLink]="['/' + productPagePath, data?.product.popup_raffle?.slug]"
      (click)="
        enterNowCrossSell(data?.product.popup_raffle?.id); dialogRef.close()
      "
      [ngClass]="{
        'button button_no-shadow button_blue button_icon':
          data.projectCode === '7days',
        'button-new button-new__small button-new__primary button-new__icon':
          data.projectCode === 'ukcarp'
      }"
    >
      Enter Here
      <svg-icon name="ticket-small"></svg-icon>
    </a>
    <a
      *ngIf="data?.product.popup_category"
      [routerLink]="['/', data?.product.popup_category?.slug]"
      (click)="
        enterNowCrossSell(data?.product.popup_raffle?.id); dialogRef.close()
      "
      [ngClass]="{
        'button button_no-shadow button_blue button_icon':
          data.projectCode === '7days',
        'button-new button-new__small button-new__primary button-new__icon':
          data.projectCode === 'ukcarp'
      }"
    >
      Enter Here
      <svg-icon name="ticket-small"></svg-icon>
    </a>
  </div>
</div>

<ng-template #toCartTmpl>
  <a
    [ngClass]="{
      'button button_no-shadow button_blue': data.projectCode === '7days',
      'button-new button-new__small button-new__primary':
        data.projectCode === 'ukcarp'
    }"
    [routerLink]="['/' + cartPagePath]"
    (click)="dialogRef.close()"
    >View basket</a
  >
</ng-template>
